export function initCustomerObject() {
    return (
        {
            id: null,
            siren: "",
            ape_code: "",
            company_name: "",
            enedis_certificate: false,
            first_name: "",
            last_name: "",
            address: "",
            postal_code: "",
            city: "",
            structures: []
        }
    )
}

export function buildCustomerFormDataBuilder(customer) {    
    const formData = new FormData();

    if (customer.id)
        formData.append('customer[id]', customer.id);

    formData.append('customer[siren]',          customer.siren); 
    formData.append('customer[company_name]',   customer.company_name ?? ""); 
    formData.append('customer[trade_name]',     customer.trade_name ?? ""); 
    formData.append('customer[first_name]',     customer.first_name ?? ""); 
    formData.append('customer[last_name]',      customer.last_name ?? "");
    formData.append('customer[ape_code]',       customer.ape_code ?? "");
    formData.append('customer[address]',        customer.address ?? "");
    formData.append('customer[postal_code]',    customer.postal_code ?? "");
    formData.append('customer[city]',           customer.city ?? "");

    customer.structures.forEach((structure, index) => {
        const key = 'customer[structures_attributes][]';

        if (structure.id)
            formData.append(`${key}[id]`, structure.id);
        
        formData.append(`${key}[address]`, structure.address);
        formData.append(`${key}[ape_code]`, structure.ape_code);
        formData.append(`${key}[city]`, structure.city);
        formData.append(`${key}[plm_number]`, structure.plm_number);
        formData.append(`${key}[postal_code]`, structure.postal_code);
        formData.append(`${key}[siret]`, structure.siret);
        formData.append(`${key}[trade_name]`, structure.trade_name);
    });

    return formData;
}
